import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-label="zap"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 24"
    fill="none"
    {...props}
  >
    <path
      stroke="#F55036"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11.608 1.367.966 12.475l6.583 1.687L4.6 22.63l10.641-11.108-6.583-1.687 2.95-8.468Z"
    />
  </svg>
);
export default SvgComponent;
